import { render, staticRenderFns } from "./message-form.vue?vue&type=template&id=63d4e1f1"
import script from "./message-form.vue?vue&type=script&lang=js"
export * from "./message-form.vue?vue&type=script&lang=js"
import style0 from "./message-form.vue?vue&type=style&index=0&id=63d4e1f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VTextarea: require('/app/node_modules/vuetify/lib/components/VTextarea/VTextarea.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VForm: require('/app/node_modules/vuetify/lib/components/VForm/VForm.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VTextarea})
